/* ============================================================
   PSM self-hosted search & filter client (Boost replacement).
   Hydrates the psm-collection section: filter tree, refine-by,
   toolbar, product grid, pagination, in-collection search —
   straight from the Typesense backend.

   Relevance mirrors Boost's settings (SKU/Tag/Vendor high, Title
   medium, Barcode low; description non-searchable). "In stock
   first" is applied to every sort, matching live behavior.
   ============================================================ */

/* ENVO volume offer (snippets/psm-envo-volume.liquid).
   Qualifying doc: tag "Brand: Envo" AND product_type "Constant Voltage LED Driver".
   Both fields are already stored on the psm_products index; INCLUDE_FIELDS
   requests them so the card can decide without a second request. */
function psmIsEnvoCvDriver(doc) {
  if (!doc) return false;
  var type = String(doc.product_type || "").trim().toLowerCase();
  if (type !== "constant voltage led driver") return false;
  var tags = doc.tags;
  if (tags == null || tags === "") return false;
  if (typeof tags === "string") tags = tags.split(",");
  for (var i = 0; i < tags.length; i++) {
    if (String(tags[i]).trim().toLowerCase() === "brand: envo") return true;
  }
  return false;
}
if (typeof module !== "undefined" && module.exports) {
  module.exports = { psmIsEnvoCvDriver: psmIsEnvoCvDriver };
}

(function () {
  "use strict";
  if (typeof document === "undefined") return;

  var root = document.querySelector("[data-psm-search]");
  if (!root) return;

  var CFG = {
    host: root.dataset.host,
    key: root.dataset.key,
    index: root.dataset.index,
    configUrl: root.dataset.configUrl,
    collection: root.dataset.collection || "",
    perPage: parseInt(root.dataset.perPage, 10) || 24,
    isSearch: root.hasAttribute("data-query"),
  };
  var BEST_SELLER_MIN = 20; // sold_90d threshold for the "Best Seller" badge on search rows

  // mirrors stores/psm/store.yml search block
  var QUERY_BY = "skus,tags,vendor,product_type,options_flat,title,barcode";
  var QUERY_WEIGHTS = "10,8,8,4,4,4,1";
  var NUM_TYPOS = "1,1,1,2,2,2,0";

  var SORTS = [
    { value: "relevance", label: "Relevance" },
    { value: "best-selling", label: "Best selling" },
    { value: "manual", label: "Manual" },
    { value: "title-ascending", label: "Title ascending" },
    { value: "title-descending", label: "Title descending" },
    { value: "price-ascending", label: "Price ascending" },
    { value: "price-descending", label: "Price descending" },
    { value: "created-ascending", label: "Created ascending" },
    { value: "created-descending", label: "Created descending" },
  ];

  // every sort keeps in-stock products first (Boost parity)
  function sortBy(sort, hasQuery) {
    switch (sort) {
      case "relevance":
        return hasQuery ? "_text_match:desc,in_stock:desc,sold_90d:desc"
                        : "in_stock:desc,sold_90d:desc,total_inventory:desc";
      case "title-ascending": return "in_stock:desc,title:asc";
      case "title-descending": return "in_stock:desc,title:desc";
      case "price-ascending": return "in_stock:desc,price_min:asc";
      case "price-descending": return "in_stock:desc,price_min:desc";
      case "created-ascending": return "in_stock:desc,created_at:asc";
      case "created-descending": return "in_stock:desc,created_at:desc";
      case "manual":
      case "best-selling":
      default:
        return hasQuery ? "_text_match:desc,in_stock:desc,sold_90d:desc"
                        : "in_stock:desc,sold_90d:desc,total_inventory:desc";
    }
  }

  /* ---------------- state <-> URL ---------------- */
  var state = {
    q: root.dataset.query || "",
    filters: {},   // field -> [values]
    ranges: {},    // field -> [min, max]
    sort: "best-selling",
    page: 1,
    view: "grid",
  };
  var defaultSort = state.q ? "relevance" : "best-selling";
  state.sort = defaultSort;

  function readURL() {
    var p = new URLSearchParams(location.search);
    state.q = p.get("q") || root.dataset.query || "";
    state.sort = p.get("sort") || (state.q ? "relevance" : "best-selling");
    state.page = parseInt(p.get("page"), 10) || 1;
    state.view = p.get("view") === "list" ? "list" : "grid";
    state.filters = {};
    state.ranges = {};
    p.forEach(function (v, k) {
      if (k.indexOf("f_") === 0) {
        var f = k.slice(2);
        (state.filters[f] = state.filters[f] || []).push(v);
      } else if (k.indexOf("r_") === 0) {
        var parts = v.split(":");
        if (parts.length === 2) state.ranges[k.slice(2)] = [parseFloat(parts[0]), parseFloat(parts[1])];
      }
    });
  }

  function writeURL(replace) {
    var p = new URLSearchParams();
    if (state.q) p.set("q", state.q);
    if (state.sort !== (state.q ? "relevance" : "best-selling")) p.set("sort", state.sort);
    if (state.page > 1) p.set("page", String(state.page));
    if (state.view === "list") p.set("view", "list");
    Object.keys(state.filters).forEach(function (f) {
      state.filters[f].forEach(function (v) { p.append("f_" + f, v); });
    });
    Object.keys(state.ranges).forEach(function (f) {
      p.set("r_" + f, state.ranges[f][0] + ":" + state.ranges[f][1]);
    });
    var qs = p.toString();
    var url = location.pathname + (qs ? "?" + qs : "");
    if (replace) history.replaceState(null, "", url);
    else history.pushState(null, "", url);
  }

  /* ---------------- engine queries ---------------- */
  var tree = null;        // active filter tree (options array)
  var rangeBounds = {};   // field -> {min,max} from unfiltered stats

  function esc(v) { return String(v).replace(/`/g, ""); }

  // expand a selected value: if it is a merge-group label, replace it with the
  // underlying raw facet values that merge into it.
  function expandMerge(opt, vals) {
    if (!opt || !opt.merge) return vals;
    var reverse = {};
    Object.keys(opt.merge).forEach(function (raw) {
      var g = opt.merge[raw];
      (reverse[g] = reverse[g] || []).push(raw);
    });
    var out = [];
    vals.forEach(function (v) { if (reverse[v]) out = out.concat(reverse[v]); else out.push(v); });
    return out;
  }

  function filterClause(excludeField) {
    var parts = [];
    var optByField = {};
    tree.options.forEach(function (o) { optByField[o.field] = o; });
    if (CFG.collection) parts.push("collections:=`" + esc(CFG.collection) + "`");
    else if (CFG.isSearch) parts.push("collections:!=`hidden-products`"); // hide combined-listing parent landing pages from search
    Object.keys(state.filters).forEach(function (f) {
      if (f === excludeField) return;
      var vals = state.filters[f];
      if (!vals.length) return;
      if (f === "available" || f === "in_stock") {
        parts.push(f + ":=" + (vals.indexOf("true") >= 0 ? "true" : "false"));
      } else {
        var raw = expandMerge(optByField[f], vals);
        parts.push(f + ":=[" + raw.map(function (v) { return "`" + esc(v) + "`"; }).join(",") + "]");
      }
    });
    Object.keys(state.ranges).forEach(function (f) {
      if (f === excludeField) return;
      var r = state.ranges[f];
      parts.push(f + ":[" + r[0] + ".." + r[1] + "]");
    });
    return parts.join(" && ");
  }

  var INCLUDE_FIELDS = "id,handle,url,title,vendor,subtitle,skus,price_min,compare_at_min,image,available,first_qty,variant_id,variants_count,sold_90d,tags,product_type";

  function buildSearches() {
    var facetFields = tree.options.map(function (o) { return o.field; });
    var hasQuery = !!state.q;
    var main = {
      collection: CFG.index,
      q: state.q || "*",
      query_by: QUERY_BY,
      query_by_weights: QUERY_WEIGHTS,
      num_typos: NUM_TYPOS,
      prefix: true,
      max_candidates: 100,
      filter_by: filterClause(null),
      facet_by: facetFields.join(","),
      max_facet_values: 100,
      sort_by: sortBy(state.sort, hasQuery),
      stopwords: CFG.stopwordsSet || undefined,
      page: state.page,
      per_page: CFG.perPage,
      include_fields: INCLUDE_FIELDS,
      highlight_fields: "none",
    };
    var searches = [main];
    // disjunctive facets: each actively-filtered option re-queried without
    // its own filter so sibling values keep their counts (Boost behavior)
    var activeFields = Object.keys(state.filters).concat(Object.keys(state.ranges));
    activeFields.forEach(function (f) {
      if (facetFields.indexOf(f) < 0) return;
      searches.push({
        collection: CFG.index,
        q: state.q || "*",
        query_by: QUERY_BY,
        query_by_weights: QUERY_WEIGHTS,
        num_typos: NUM_TYPOS,
        prefix: true,
        max_candidates: 100,
        filter_by: filterClause(f),
        facet_by: f,
        max_facet_values: 100,
        per_page: 0,
        highlight_fields: "none",
      });
    });
    return searches;
  }

  var inflight = null;
  var firstQuery = true;
  function runQuery() {
    if (!firstQuery) root.classList.add("psm-loading");
    firstQuery = false;
    var searches = buildSearches();
    var ctrl = new AbortController();
    if (inflight) inflight.abort();
    inflight = ctrl;
    return fetch(CFG.host + "/multi_search", {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-TYPESENSE-API-KEY": CFG.key },
      body: JSON.stringify({ searches: searches }),
      signal: ctrl.signal,
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        inflight = null;
        root.classList.remove("psm-loading");
        var results = data.results || [];
        var main = results[0] || {};
        // Self-heal: a facet_by field absent from the Typesense schema makes the
        // ENTIRE search fail (Typesense returns an error result, blanking the
        // collection). Drop the offending field from the active tree and retry,
        // rather than showing zero products. Each bad field is dropped once, so
        // this terminates. Keeps collections working under config/schema drift.
        var errMsg = main.error || (main.hits ? "" : data.message) || "";
        var badFacet = /facet field named `?([A-Za-z0-9_.]+)`?/.exec(errMsg);
        if (badFacet && tree && tree.options.some(function (o) { return o.field === badFacet[1]; })) {
          tree.options = tree.options.filter(function (o) { return o.field !== badFacet[1]; });
          if (window.console) console.warn("[psm-search] dropped unknown facet field:", badFacet[1]); // eslint-disable-line no-console
          return runQuery();
        }
        // overlay disjunctive facet results
        var facets = {};
        (main.facet_counts || []).forEach(function (fc) { facets[fc.field_name] = fc; });
        // Overlay each disjunctive-facet result by its OWN field name. Keying off
        // the result (not the active-field index) keeps counts correct even when
        // an active field — e.g. a price range — was skipped in buildSearches.
        results.slice(1).forEach(function (r) {
          if (r && r.facet_counts && r.facet_counts[0]) facets[r.facet_counts[0].field_name] = r.facet_counts[0];
        });
        render(main, facets);
      })
      .catch(function (e) {
        if (e.name !== "AbortError") {
          root.classList.remove("psm-loading");
          console.error("[psm-search]", e);
        }
      });
  }

  /* ---------------- rendering ---------------- */
  var el = {
    facets: document.getElementById("psm-facets"),
    treeBox: document.getElementById("psm-filter-tree"),
    toolbar: document.getElementById("psm-toolbar"),
    grid: document.getElementById("psm-grid"),
    pagination: document.getElementById("psm-pagination"),
    icsInput: document.getElementById("psm-ics-input"),
    icsBtn: document.getElementById("psm-ics-btn"),
  };

  function h(html) {
    var d = document.createElement("div");
    d.innerHTML = html.trim();
    return d.firstChild;
  }
  function escHtml(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function money(n) {
    if (n == null) return "";
    return "$" + Number(n).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  function imgUrl(u, w) {
    if (!u) return "";
    return u + (u.indexOf("?") >= 0 ? "&" : "?") + "width=" + w;
  }

  /* ----- automatic-discount campaigns -----
     Data inlined by snippets/psm-campaigns-inline.liquid (mirror of the store's
     Shopify automatic discounts; labels already resolved server-side). The date
     window is re-checked here because collection pages can sit in the edge
     cache past a campaign's end. Prices: doc.price_min is in dollars. */
  var CAMPAIGN_BY_HANDLE = {};
  (function () {
    var node = document.getElementById("psm-campaigns");
    if (!node) return;
    var list;
    try { list = JSON.parse(node.textContent) || []; } catch (e) { return; }
    var now = Date.now();
    list.forEach(function (c) {
      if (c.starts_at && Date.parse(c.starts_at) > now) return;
      if (c.ends_at && Date.parse(c.ends_at) < now) return;
      (c.handles || []).forEach(function (hd) {
        if (!CAMPAIGN_BY_HANDLE[hd]) CAMPAIGN_BY_HANDLE[hd] = c;
      });
    });
  })();
  function campaignFor(doc) {
    return CAMPAIGN_BY_HANDLE[doc.handle] || null;
  }
  function campaignPrice(p, c) {
    // c.value: percent int for "percent", cents for "amount"; p is dollars
    return c.type === "amount" ? Math.max(0, Math.round(p * 100 - c.value) / 100) : Math.round(p * (100 - c.value)) / 100;
  }
  function campaignOffText(c) {
    return c.type === "amount" ? "−" + money(c.value / 100) : "−" + c.value + "%";
  }
  function campaignStripOff(c) {
    return c.type === "amount" ? money(c.value / 100) + " off" : c.value + "% off";
  }
  function campaignEnds(c) {
    if (!c.ends_at) return "";
    var d = new Date(c.ends_at);
    if (isNaN(d)) return "";
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return " · ends " + months[d.getMonth()] + " " + d.getDate();
  }

  /* ----- filter tree ----- */
  var collapsed = {};   // field -> bool
  var valueSearch = {}; // field -> filter text

  function displayLabel(opt, value) {
    if (opt.values && opt.values[value]) return opt.values[value];
    return value;
  }

  function renderTree(facets) {
    var box = el.treeBox;
    box.hidden = false;
    box.innerHTML = "";

    // refine-by chips
    var chips = [];
    tree.options.forEach(function (opt) {
      (state.filters[opt.field] || []).forEach(function (v) {
        chips.push({ field: opt.field, value: v, label: opt.label, display: displayLabel(opt, v), range: false });
      });
      if (state.ranges[opt.field]) {
        var r = state.ranges[opt.field];
        chips.push({ field: opt.field, label: opt.label, display: r[0] + " – " + r[1], range: true });
      }
    });
    if (chips.length) {
      var rb = h('<div class="boost-sd__refine-by-vertical-refine-by">' +
        '<div class="boost-sd__refine-by-vertical-refine-by-title">' +
        '<div class="boost-sd__refine-by-vertical-refine-by-heading" role="heading" aria-level="2">Refine By</div>' +
        '<button type="button" aria-label="Clear all filters" class="boost-sd__button boost-sd__button--clear"><span class="boost-sd__button-text">Clear All</span></button>' +
        '</div><div class="boost-sd__refine-by-vertical-refine-by-list"></div></div>');
      rb.querySelector(".boost-sd__button--clear").addEventListener("click", function () {
        state.filters = {};
        state.ranges = {};
        state.page = 1;
        apply();
      });
      var list = rb.querySelector(".boost-sd__refine-by-vertical-refine-by-list");
      chips.forEach(function (c) {
        var chip = h('<button aria-label="Clear filter" class="boost-sd__refine-by-vertical-refine-by-item">' +
          '<span class="boost-sd__refine-by-vertical-refine-by-type">' +
          '<span class="boost-sd__refine-by-vertical-refine-by-option">' + escHtml(c.label) + ": </span>" +
          '<span class="boost-sd__refine-by-vertical-refine-by-value"> ' + escHtml(c.display) + "</span></span>" +
          '<svg class="boost-sd__refine-by-vertical-refine-by-clear" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 2l8 8M10 2l-8 8" stroke="#3D4246" stroke-width="1.6" stroke-linecap="round"/></svg>' +
          "</button>");
        chip.addEventListener("click", function () {
          if (c.range) delete state.ranges[c.field];
          else {
            state.filters[c.field] = (state.filters[c.field] || []).filter(function (v) { return v !== c.value; });
            if (!state.filters[c.field].length) delete state.filters[c.field];
          }
          state.page = 1;
          apply();
        });
        list.appendChild(chip);
      });
      box.appendChild(rb);
    }

    var listWrap = h('<div class="boost-sd__filter-tree-vertical-option-list"></div>');
    tree.options.forEach(function (opt) {
      var fc = facets[opt.field];
      var node;
      if (opt.display === "range") node = renderRangeOption(opt, fc);
      else if (opt.display === "box") node = renderBoxOption(opt, fc);
      else node = renderListOption(opt, fc);
      if (node) listWrap.appendChild(node);
    });
    box.appendChild(listWrap);
  }

  function optionShell(opt, contentNode) {
    if (collapsed[opt.field] === undefined && opt.collapsed) collapsed[opt.field] = true; // config default
    var blk = h('<div class="boost-sd__filter-block"><div class="boost-sd__filter-option' +
      (collapsed[opt.field] ? " boost-sd__filter-option--collapsed" : "") + '">' +
      '<button type="button" class="boost-sd__filter-option-label" aria-expanded="' + (!collapsed[opt.field]) + '">' +
      '<svg class="boost-sd__filter-option-icon" width="10" height="7" viewBox="0 0 10 6"><path d="M0 0h10L5 6z" fill="currentColor"/></svg>' +
      '<span class="boost-sd__filter-option-title">' + escHtml(opt.label) + "</span>" +
      "</button>" +
      '<div class="boost-sd__filter-option-content-inner"></div>' +
      "</div></div>");
    blk.querySelector(".boost-sd__filter-option-label").addEventListener("click", function () {
      collapsed[opt.field] = !collapsed[opt.field];
      var o = blk.querySelector(".boost-sd__filter-option");
      o.classList.toggle("boost-sd__filter-option--collapsed", collapsed[opt.field]);
      this.setAttribute("aria-expanded", String(!collapsed[opt.field]));
    });
    blk.querySelector(".boost-sd__filter-option-content-inner").appendChild(contentNode);
    return blk;
  }

  function renderListOption(opt, fc) {
    var body = listBody(opt, fc, false);
    return body ? optionShell(opt, body) : null;
  }

  function renderBoxOption(opt, fc) {
    var body = listBody(opt, fc, true);
    return body ? optionShell(opt, body) : null;
  }

  function isGroup(opt, key) {
    if (!opt.merge) return false;
    for (var raw in opt.merge) { if (opt.merge[raw] === key) return true; }
    return false;
  }
  function itemMembers(opt, key) {
    if (opt.merge) { var m = []; for (var raw in opt.merge) { if (opt.merge[raw] === key) m.push(raw); } if (m.length) return m; }
    return [key];
  }

  // Build display items: hide -> merge/group -> keep-selected -> sort.
  function buildItems(opt, fc) {
    var counts = (fc && fc.counts) || [];
    var hide = opt.hide || [];
    var items = [], byKey = {};
    counts.forEach(function (c) {
      if (c.count <= 0) return;
      var v = String(c.value);
      if (hide.indexOf(v) >= 0) return;
      var g = opt.merge && opt.merge[v];
      var key = g || v;
      if (byKey[key]) { byKey[key].count += c.count; byKey[key].members.push(v); }
      else { var it = { key: key, label: g || displayLabel(opt, v), count: c.count, members: [v] }; byKey[key] = it; items.push(it); }
    });
    (state.filters[opt.field] || []).forEach(function (k) {  // keep selected visible at 0
      if (!byKey[k]) { var it = { key: k, label: isGroup(opt, k) ? k : displayLabel(opt, k), count: 0, members: itemMembers(opt, k) }; byKey[k] = it; items.push(it); }
    });
    var mode = opt.sort || "count";
    if (mode === "numeric") items.sort(function (a, b) { return parseFloat(a.key) - parseFloat(b.key); });
    else if (mode === "alpha") items.sort(function (a, b) { return String(a.label).localeCompare(String(b.label)); });
    else if (mode === "manual" && opt.order && opt.order.length) {
      var ord = opt.order;
      items.sort(function (a, b) { var ia = ord.indexOf(a.key), ib = ord.indexOf(b.key); return (ia < 0 ? 1e9 : ia) - (ib < 0 ? 1e9 : ib); });
    }
    return items;
  }

  function toggleItem(opt, key) {
    var cur = state.filters[opt.field] || [];
    if (opt.multi === false) state.filters[opt.field] = cur.indexOf(key) >= 0 ? [] : [key];
    else { if (cur.indexOf(key) >= 0) cur = cur.filter(function (x) { return x !== key; }); else cur = cur.concat([key]); state.filters[opt.field] = cur; }
    if (!state.filters[opt.field].length) delete state.filters[opt.field];
    state.page = 1;
    apply();
  }

  // "View more" — hide items beyond opt.limit behind a toggle button.
  function applyLimit(wrap, els, limit) {
    if (!limit || els.length <= limit) return;
    var extra = els.slice(limit), shown = false;
    extra.forEach(function (e) { e.style.display = "none"; });
    var btn = h('<button type="button" class="boost-sd__show-more-btn">Show ' + extra.length + ' more</button>');
    btn.addEventListener("click", function () {
      shown = !shown;
      extra.forEach(function (e) { e.style.display = shown ? "" : "none"; });
      btn.textContent = shown ? "Show less" : ("Show " + extra.length + " more");
    });
    wrap.appendChild(btn);
  }

  // Shared list/box body — asButtons=true renders the "box" display.
  function listBody(opt, fc, asButtons) {
    var items = buildItems(opt, fc);
    if (!items.length) return null;
    var selected = state.filters[opt.field] || [];
    var wrap = document.createElement("div");
    var filterText = (valueSearch[opt.field] || "").toLowerCase();
    var els = [];

    if (!asButtons && items.length > 7) {  // in-filter value search (lists only)
      var so = h('<div class="boost-sd__filter-option-search-option"><input type="search" placeholder="Search Options" aria-label="Search ' + escHtml(opt.label) + '" value="' + escHtml(valueSearch[opt.field] || "") + '"></div>');
      so.querySelector("input").addEventListener("input", function () {
        valueSearch[opt.field] = this.value;
        var ft = this.value.toLowerCase();
        wrap.querySelectorAll("[data-v]").forEach(function (li) { li.style.display = li.dataset.v.toLowerCase().indexOf(ft) >= 0 ? "" : "none"; });
      });
      wrap.appendChild(so);
    }

    var container;
    if (asButtons) {
      container = h('<div class="boost-sd__filter-option-box-wrap"></div>');
    } else {
      // scroll-cap a long list — but NOT when it uses an explicit view-more limit
      // (then "Show more" should expand the list in full, not into an inner scroll)
      var scrollable = items.length > 7 && !opt.limit;
      container = h('<ul class="boost-sd__filter-option-itemwrapper' + (scrollable ? " boost-sd__filter-option-itemwrapper--scrollable" : "") + '"></ul>');
    }
    items.forEach(function (it) {
      var isSel = selected.indexOf(it.key) >= 0;
      var node;
      if (asButtons) {
        node = h('<button type="button" class="boost-sd__filter-box-item' + (isSel ? " boost-sd__filter-box-item--selected" : "") + '" data-v="' + escHtml(it.key) + '">' +
          escHtml(it.label) + ' <span class="boost-sd__filter-box-amount">' + it.count + "</span></button>");
      } else {
        node = h('<li class="boost-sd__filter-option-listitem boost-sd__filter-option-list-option-item" data-v="' + escHtml(it.key) + '">' +
          '<button role="checkbox" aria-checked="' + isSel + '" class="boost-sd__filter-option-item-button boost-sd__filter-option-item-button--as-button boost-sd__filter-option-item-button--with-checkbox' + (isSel ? " boost-sd__filter-option-item-button--selected" : "") + '">' +
          '<span class="boost-sd__filter-option-item-label">' + escHtml(it.label) + "</span>" +
          '<span class="boost-sd__filter-option-item-amount' + (isSel ? " boost-sd__filter-option-item-amount--selected" : "") + '">(' + it.count + ")</span>" +
          "</button></li>");
      }
      if (filterText && it.key.toLowerCase().indexOf(filterText) < 0) node.style.display = "none";
      (asButtons ? node : node.querySelector("button")).addEventListener("click", function () { toggleItem(opt, it.key); });
      container.appendChild(node);
      els.push(node);
    });
    wrap.appendChild(container);
    if (!filterText) applyLimit(wrap, els, opt.limit);
    return wrap;
  }

  function renderRangeOption(opt, fc) {
    var step = opt.step || 1;
    var stats = fc && fc.stats;
    var bounds = rangeBounds[opt.field];
    if (stats && typeof stats.min === "number" && typeof stats.max === "number") {
      bounds = rangeBounds[opt.field] = {
        min: Math.floor(stats.min / step) * step,
        max: Math.ceil(stats.max / step) * step,
      };
      // avoid float drift like 0.30000000000000004
      bounds.min = parseFloat(bounds.min.toFixed(4));
      bounds.max = parseFloat(bounds.max.toFixed(4));
    }
    if (!bounds || bounds.min === bounds.max) return null;
    var cur = state.ranges[opt.field] || [bounds.min, bounds.max];
    var lo = Math.max(bounds.min, Math.min(cur[0], bounds.max));
    var hi = Math.min(bounds.max, Math.max(cur[1], bounds.min));
    var unit = opt.money ? "$" : "";
    var suffix = opt.unit ? " " + opt.unit : "";

    var wrap = h('<div class="boost-sd__filter-option-range-slider boost-sd__filter-option-range-slider--style-1">' +
      '<div class="boost-sd__filter-option-range-slider-input-wrapper">' +
      '<input type="number" class="boost-sd__filter-option-range-slider-input psm-num-lo" min="' + bounds.min + '" max="' + bounds.max + '" step="' + step + '" value="' + lo + '" aria-label="Minimum ' + escHtml(opt.label) + '">' +
      '<span class="boost-sd__filter-option-range-slider-input-split">&ndash;</span>' +
      '<input type="number" class="boost-sd__filter-option-range-slider-input psm-num-hi" min="' + bounds.min + '" max="' + bounds.max + '" step="' + step + '" value="' + hi + '" aria-label="Maximum ' + escHtml(opt.label) + '">' +
      "</div>" +
      '<div class="psm-range-track">' +
      '<div class="psm-range-fill"></div>' +
      '<input type="range" class="psm-range-lo" min="' + bounds.min + '" max="' + bounds.max + '" step="' + step + '" value="' + lo + '" aria-label="Minimum">' +
      '<input type="range" class="psm-range-hi" min="' + bounds.min + '" max="' + bounds.max + '" step="' + step + '" value="' + hi + '" aria-label="Maximum">' +
      "</div>" +
      '<div class="psm-range-bounds"><span>' + unit + bounds.min + '</span><span>' + unit + bounds.max + "</span></div>" +
      "</div>");

    var rl = wrap.querySelector(".psm-range-lo"), rh = wrap.querySelector(".psm-range-hi");
    var nl = wrap.querySelector(".psm-num-lo"), nh = wrap.querySelector(".psm-num-hi");
    var fill = wrap.querySelector(".psm-range-fill");

    function paint() {
      var a = parseFloat(rl.value), b = parseFloat(rh.value);
      if (a > b) { var t = a; a = b; b = t; }
      var span = bounds.max - bounds.min || 1;
      fill.style.left = ((a - bounds.min) / span) * 100 + "%";
      fill.style.width = ((b - a) / span) * 100 + "%";
      nl.value = a;
      nh.value = b;
    }
    paint();

    var commitTimer = null;
    function commit() {
      clearTimeout(commitTimer);
      commitTimer = setTimeout(function () {
        var a = parseFloat(rl.value), b = parseFloat(rh.value);
        if (a > b) { var t = a; a = b; b = t; }
        if (a <= bounds.min && b >= bounds.max) delete state.ranges[opt.field];
        else state.ranges[opt.field] = [a, b];
        state.page = 1;
        apply();
      }, 350);
    }
    [rl, rh].forEach(function (inp) {
      inp.addEventListener("input", paint);
      inp.addEventListener("change", commit);
    });
    [nl, nh].forEach(function (inp, i) {
      inp.addEventListener("change", function () {
        var v = parseFloat(this.value);
        if (isNaN(v)) return;
        if (i === 0) rl.value = Math.max(bounds.min, Math.min(v, parseFloat(rh.value)));
        else rh.value = Math.min(bounds.max, Math.max(v, parseFloat(rl.value)));
        paint();
        commit();
      });
    });
    return optionShell(opt, wrap);
  }

  /* ----- toolbar ----- */
  function renderToolbar(found) {
    var shownFrom = found === 0 ? 0 : (state.page - 1) * CFG.perPage + 1;
    var shownTo = Math.min(found, state.page * CFG.perPage);
    var activeSort = SORTS.filter(function (s) { return s.value === state.sort; })[0] || SORTS[1];

    var tb = h('<div class="boost-sd__toolbar boost-sd__toolbar--3_1">' +
      '<div class="boost-sd__toolbar-item boost-sd__toolbar-item--product-count">' +
      '<div class="boost-sd__product-count">Showing <b>' + shownFrom + "&ndash;" + shownTo + "</b> of <b>" + found.toLocaleString() + '</b> products · <span class="psm-instock-first">In stock first</span></div></div>' +
      '<button type="button" class="psm-filter-toggle" aria-label="Open filters">' +
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M4 6h16M7 12h10M10 18h4"/></svg>Filter</button>' +
      '<div class="boost-sd__toolbar-item boost-sd__toolbar-item--sorting"><div class="boost-sd__toolbar-top-mobile"><div class="boost-sd__sorting">' +
      '<button type="button" class="boost-sd__sorting-button" aria-haspopup="listbox">' +
      '<div class="boost-sd__sorting-label-wrapper"><span class="boost-sd__sorting-label">Sort</span><span class="boost-sd__sorting-value">' + escHtml(activeSort.label) + "</span></div></button>" +
      '<ul class="boost-sd__sorting-list" role="listbox"></ul>' +
      "</div></div></div>" +
      '<div class="boost-sd__toolbar-item boost-sd__toolbar-item--view-as"><div class="boost-sd__view-as">' +
      '<div class="boost-sd__view-as-text">View as</div>' +
      '<div class="boost-sd__tooltip" data-view="grid"><div class="boost-sd__tooltip-content">Grid view</div><span class="boost-sd__view-as-icon boost-sd__view-as-icon--grid boost-sd__view-as-icon--list-grid' + (state.view === "grid" ? " boost-sd__view-as-icon--active" : "") + '"></span></div>' +
      '<div class="boost-sd__tooltip" data-view="list"><div class="boost-sd__tooltip-content">List view</div><span class="boost-sd__view-as-icon boost-sd__view-as-icon--list boost-sd__view-as-icon--list-grid' + (state.view === "list" ? " boost-sd__view-as-icon--active" : "") + '"></span></div>' +
      "</div></div></div>");

    var sorting = tb.querySelector(".boost-sd__sorting");
    var list = tb.querySelector(".boost-sd__sorting-list");
    SORTS.forEach(function (s) {
      var li = h('<li class="boost-sd__sorting-option' + (s.value === state.sort ? " boost-sd__sorting-option--active" : "") + '" role="option" data-value="' + s.value + '">' + escHtml(s.label) + "</li>");
      li.addEventListener("click", function () {
        state.sort = s.value;
        state.page = 1;
        sorting.classList.remove("boost-sd__sorting--open");
        apply();
      });
      list.appendChild(li);
    });
    tb.querySelector(".boost-sd__sorting-button").addEventListener("click", function (e) {
      e.stopPropagation();
      sorting.classList.toggle("boost-sd__sorting--open");
    });
    tb.querySelectorAll(".boost-sd__view-as .boost-sd__tooltip").forEach(function (t) {
      t.addEventListener("click", function () {
        if (state.view === t.dataset.view) return;
        state.view = t.dataset.view;
        apply();
      });
    });
    tb.querySelector(".psm-filter-toggle").addEventListener("click", function () {
      root.classList.add("psm-drawer-open");
    });

    el.toolbar.innerHTML = "";
    el.toolbar.appendChild(tb);
  }

  document.addEventListener("click", function () {
    var open = el.toolbar.querySelector(".boost-sd__sorting--open");
    if (open) open.classList.remove("boost-sd__sorting--open");
  });

  /* ----- product cards ----- */
  // Same copy as snippets/psm-envo-volume.liquid (context: card).
  // B2B company customers: theme.liquid sets theme.promo.audience.isB2B from customer.b2b?.
  function envoCardBadge(doc) {
    if (!psmIsEnvoCvDriver(doc)) return "";
    var aud = window.theme && window.theme.promo && window.theme.promo.audience;
    if (aud && aud.isB2B) return "";
    return '<span class="psm-envo-badge" title="10% off 10+ ENVO LED drivers, mix &amp; match. US orders, applied automatically at checkout."><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2 3 6.5 12 11l9-4.5L12 2Z"/><path d="M3 11.5 12 16l9-4.5"/><path d="M3 16.5 12 21l9-4.5"/></svg><span><b>10% off</b> · 10+ units</span></span>';
  }

  function renderCard(doc, idx) {
    var eager = idx < 6;
    var sku = (doc.skus && doc.skus[0]) || "";
    var onSale = doc.compare_at_min && doc.compare_at_min > doc.price_min;
    // Campaign pricing: shown price becomes the campaign price and the store
    // price moves to the compare slot (MSRP compare-at is ignored meanwhile —
    // the discount is off our price). Mirrors snippets/psm-search-card.liquid.
    var camp = campaignFor(doc);
    var campPriced = camp && camp.show_price !== false;
    var curPrice = campPriced ? campaignPrice(doc.price_min, camp) : doc.price_min;
    var wasPrice = campPriced ? doc.price_min : (onSale ? doc.compare_at_min : null);
    var inStock = (doc.first_qty || 0) > 0;
    var multi = (doc.variants_count || 1) > 1;
    var listView = state.view === "list";
    // link within the collection so the product page keeps the breadcrumb
    // canonical product URL, as the Liquid card (snippets/psm-search-card.liquid) uses product.url
    var url = doc.url || "/products/" + doc.handle; // canonical product URL (SEO: no /collections/<c>/products/ variant)

    var html = '<div class="boost-sd__product-item boost-sd__product-item--no-border boost-sd__product-item-grid-view-layout' + (listView ? " boost-sd__product-item-list-view" : "") + '" data-product-id="' + doc.id + '">' +
      // campaign strip above the image ("B" treatment) — zero image occlusion
      (camp ? '<div class="psm-campaign-strip"><span class="psm-campaign-strip-label">' + escHtml(camp.label) + '</span><span class="psm-campaign-strip-off">' + escHtml(campaignStripOff(camp)) + "</span></div>" : "") +
      '<div class="boost-sd__product-item-grid-view-layout-image">' +
      '<a class="boost-sd__product-link boost-sd__product-link-image" href="' + escHtml(url) + '">' +
      '<div class="boost-sd__product-image-wrapper boost-sd__product-image-wrapper--natural">' +
      '<div class="boost-sd__product-image pl-parent">' +
      envoCardBadge(doc) +
      (doc.image ? '<img class="boost-sd__product-image-img boost-sd__product-image-img--main" src="' + escHtml(imgUrl(doc.image, 400)) + '" srcset="' + escHtml(imgUrl(doc.image, 400)) + ' 400w, ' + escHtml(imgUrl(doc.image, 600)) + ' 600w, ' + escHtml(imgUrl(doc.image, 800)) + ' 800w" sizes="265px" loading="' + (eager ? "eager\" fetchpriority=\"high" : "lazy") + '" decoding="async" alt="' + escHtml(doc.title) + '">' : "") +
      '<div class="pl-collection pl-container" data-label-product-handle="' + escHtml(doc.handle) + '"></div>' +
      "</div>" +
      "</div></a></div>" +
      '<a class="boost-sd__product-link" href="' + escHtml(url) + '">' +
      '<div class="boost-sd__product-info pl-badge-container pl-badge-collection">' +
      '<div class="boost-sd__product-vendor">' + escHtml(doc.vendor) + "</div>" +
      '<div class="boost-sd__product-title">' + escHtml(doc.title) + "</div>" +
      (sku ? '<span class="psm-card-sku">' + escHtml(sku) + "</span>" : "") +
      (doc.subtitle ? '<div class="caption-with-letter-spacing light basic-subtitle">' + escHtml(doc.subtitle) + "</div>" : "") +
      '<div class="boost-sd__atc-wl-wrapper"><div class="boost-sd__product-price"><div class="boost-sd__product-price-wrapper">' +
      '<span class="boost-sd__product-price-content boost-sd__product-price-content--text-align-left">' +
      '<span class="boost-sd__format-currency"><span>' + money(curPrice) + "</span></span>" +
      (wasPrice ? '<span class="boost-sd__format-currency boost-sd__format-currency--price-compare"><span>' + money(wasPrice) + "</span></span>" : "") +
      "</span></div></div></div>" +
      (inStock
        ? '<span class="psm-card-stock in"><span class="dot"></span>In stock · ships today</span>'
        : '<span class="psm-card-stock bo"><span class="dot"></span>Backorder · 2&ndash;3 weeks</span>') +
      '<div class="psm-card-atc"><button type="button" class="psm-atc-proxy" data-variant-id="' + escHtml(doc.variant_id || "") + '" data-variants-count="' + (doc.variants_count || 1) + '" data-url="' + escHtml(url) + '">' +
      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 7h12l1.5 13.5h-15L6 7z"/><path d="M9 10V6a3 3 0 0 1 6 0v4"/></svg>' +
      (multi ? "View options" : (inStock ? "Add to cart" : "Backorder")) +
      "</button></div>" +
      "</div></a></div>";
    return h(html);
  }

  /* ----- search results: B&H-style list row ----- */
  function bhFeatures(subtitle) {
    if (!subtitle) return [];
    var parts = subtitle.split(/\s*[·|;]\s*/);
    if (parts.length < 2) parts = subtitle.split(/\s*,\s*/);
    return parts.map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 4);
  }

  function renderBhRow(doc, idx) {
    var eager = idx < 4;
    var sku = (doc.skus && doc.skus[0]) || "";
    var inStock = (doc.first_qty || 0) > 0;
    var multi = (doc.variants_count || 1) > 1;
    var onSale = doc.compare_at_min && doc.compare_at_min > doc.price_min;
    var camp = campaignFor(doc);
    var campPriced = camp && camp.show_price !== false;
    var curPrice = campPriced ? campaignPrice(doc.price_min, camp) : doc.price_min;
    var wasPrice = campPriced ? doc.price_min : (onSale ? doc.compare_at_min : null);
    var best = (doc.sold_90d || 0) >= BEST_SELLER_MIN;
    var url = doc.url || "/products/" + doc.handle; // canonical product URL (SEO: no /collections/<c>/products/ variant)
    var img = doc.image
      ? '<img src="' + escHtml(imgUrl(doc.image, 360)) + '" srcset="' + escHtml(imgUrl(doc.image, 360)) + ' 360w, ' + escHtml(imgUrl(doc.image, 540)) + ' 540w" sizes="175px" loading="' + (eager ? "eager" : "lazy") + '" decoding="async" alt="' + escHtml(doc.title) + '">'
      : "";
    var feats = bhFeatures(doc.subtitle).map(function (f) { return "<li>" + escHtml(f) + "</li>"; }).join("");
    var was = wasPrice ? ' <span class="psm-bh-was">' + money(wasPrice) + "</span>" : "";
    // campaign "C" treatment: −% chip beside the price + a small campaign line,
    // nothing over the image or title
    var chip = campPriced ? ' <span class="psm-bh-chip">' + escHtml(campaignOffText(camp)) + "</span>" : "";
    var campLine = camp ? '<div class="psm-bh-campaign">' + escHtml(camp.label + campaignEnds(camp)) + "</div>" : "";
    var save = wasPrice ? '<div class="psm-bh-save">Save ' + money(wasPrice - curPrice) + "</div>" : "";
    return h(
      '<div class="psm-bh-row">' +
        '<a class="psm-bh-media" href="' + escHtml(url) + '" tabindex="-1" aria-hidden="true"><span class="psm-bh-img">' + envoCardBadge(doc) + img + "</span></a>" +
        '<div class="psm-bh-info">' +
          (best ? '<span class="psm-bh-badge">Best Seller</span>' : "") +
          '<a class="psm-bh-title" href="' + escHtml(url) + '">' + escHtml(doc.title) + "</a>" +
          (sku ? '<div class="psm-bh-sku">' + escHtml(sku) + "</div>" : "") +
          (feats ? '<div class="psm-bh-feat-h">Key features</div><ul class="psm-bh-feats">' + feats + "</ul>" : "") +
        "</div>" +
        '<div class="psm-bh-buy">' +
          '<div class="psm-bh-price">' + money(curPrice) + was + chip + "</div>" + save + campLine +
          (inStock
            ? '<div class="psm-bh-stock in"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>In stock · ships today</div>'
            : '<div class="psm-bh-stock bo"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 8v4l2.5 2"/></svg>Backorder · 2&ndash;3 weeks</div>') +
          '<button type="button" class="psm-bh-atc psm-atc-proxy" data-variant-id="' + escHtml(doc.variant_id || "") + '" data-variants-count="' + (doc.variants_count || 1) + '" data-url="' + escHtml(url) + '">' +
          (multi ? "View options" : (inStock ? "Add to cart" : "Backorder")) + "</button>" +
          '<div class="psm-bh-ship"><b>Free US shipping</b> over $200<br>Order by 4pm ET — ships today</div>' +
        "</div>" +
      "</div>"
    );
  }

  function renderGrid(main) {
    // B&H list rows on search (always) and on the collection page's list view
    var useBh = CFG.isSearch || state.view === "list";
    el.grid.classList.remove("boost-sd__product-list--list-view");
    el.grid.classList.toggle("psm-bh-list", useBh);
    el.grid.innerHTML = "";
    var hits = main.hits || [];
    if (!hits.length) {
      var msg = CFG.isSearch
        ? "No products match your search.<br>Try a different part number or term."
        : "No products match your filters.<br>Try removing a filter.";
      el.grid.appendChild(h('<div class="psm-grid-empty">' + msg + "</div>"));
      return;
    }
    hits.forEach(function (hit, i) {
      el.grid.appendChild(useBh ? renderBhRow(hit.document, i) : renderCard(hit.document, i));
    });
  }

  /* add-to-cart (theme drawer integration) */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest ? e.target.closest(".psm-atc-proxy") : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var count = parseInt(btn.dataset.variantsCount, 10) || 1;
    if (count > 1 || !btn.dataset.variantId) {
      location.href = btn.dataset.url;
      return;
    }
    btn.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error("cart add failed " + r.status);
        return r.json();
      })
      .then(function () {
        btn.disabled = false;
        document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", { bubbles: true }));
        setTimeout(function () {
          document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:open", { bubbles: true }));
        }, 150);
      })
      .catch(function (err) {
        btn.disabled = false;
        console.error("[psm-search] add-to-cart", err);
        location.href = btn.dataset.url;
      });
  }, true);

  /* ----- pagination ----- */
  function renderPagination(found) {
    var pages = Math.max(1, Math.ceil(found / CFG.perPage));
    el.pagination.innerHTML = "";
    if (pages <= 1) return;
    var cur = Math.min(state.page, pages);

    function pageBtn(n) {
      var b = h('<button class="boost-sd__pagination-number boost-sd__pagination-number--circle' + (n === cur ? " boost-sd__pagination-number--active" : "") + '">' + n + "</button>");
      if (n !== cur) b.addEventListener("click", function () { goPage(n); });
      return b;
    }
    function dots() {
      return h('<button class="boost-sd__pagination-number boost-sd__pagination-number--disabled boost-sd__pagination-number--circle">...</button>');
    }
    function arrow(dir) {
      var b = h('<button type="button" class="boost-sd__pagination-button boost-sd__pagination-button--circle boost-sd__pagination-button--' + (dir > 0 ? "next" : "prev") + '" aria-label="' + (dir > 0 ? "Next" : "Previous") + ' page">' +
        '<span class="boost-sd__pagination-button-icon' + (dir > 0 ? " boost-sd__pagination-button-icon--right" : "") + '">' +
        '<svg width="7" height="12" viewBox="0 0 7 12" fill="none"><path d="M' + (dir > 0 ? "1 1l4.5 5L1 11" : "6 1L1.5 6 6 11") + '" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span></button>');
      b.addEventListener("click", function () { goPage(cur + dir); });
      return b;
    }

    if (cur > 1) el.pagination.appendChild(arrow(-1));
    var nums = [];
    if (pages <= 7) {
      for (var i = 1; i <= pages; i++) nums.push(i);
    } else if (cur <= 4) {
      nums = [1, 2, 3, 4, "…", pages];
    } else if (cur >= pages - 3) {
      nums = [1, "…", pages - 3, pages - 2, pages - 1, pages];
    } else {
      nums = [1, "…", cur - 1, cur, cur + 1, "…", pages];
    }
    nums.forEach(function (n) {
      el.pagination.appendChild(n === "…" ? dots() : pageBtn(n));
    });
    if (cur < pages) el.pagination.appendChild(arrow(1));
  }

  function goPage(n) {
    state.page = n;
    apply();
    var top = el.toolbar.getBoundingClientRect().top + window.scrollY - 110;
    window.scrollTo({ top: top, behavior: "smooth" });
  }

  /* ----- master render + apply ----- */
  function render(main, facets) {
    renderTree(facets);
    renderToolbar(main.found || 0);
    renderGrid(main);
    renderPagination(main.found || 0);
    var strip = document.getElementById("psm-strip-count");
    if (strip) {
      strip.textContent = " (" + (main.found || 0) + ")";
      var showing = document.getElementById("psm-strip-showing");
      if (showing) showing.textContent = "Showing " + (main.found || 0) + " results";
      var terms = document.getElementById("psm-hero-terms");
      if (terms && state.q) terms.textContent = state.q;
    }
  }

  function apply() {
    writeURL(false);
    runQuery();
  }

  /* ----- in-collection search ----- */
  var icsTimer = null;
  if (el.icsInput) {
    el.icsInput.addEventListener("input", function () {
      clearTimeout(icsTimer);
      var v = this.value.trim();
      icsTimer = setTimeout(function () {
        if (v === state.q) return;
        state.q = v;
        state.page = 1;
        apply();
      }, 350);
    });
    el.icsInput.addEventListener("keydown", function (e) {
      if (e.key === "Enter") {
        clearTimeout(icsTimer);
        state.q = this.value.trim();
        state.page = 1;
        apply();
      }
    });
  }
  if (el.icsBtn) {
    el.icsBtn.addEventListener("click", function () {
      state.q = el.icsInput.value.trim();
      state.page = 1;
      apply();
    });
  }

  /* ----- search hero (SRP only) ----- */
  var heroInput = document.getElementById("psm-hero-input");
  var heroClear = document.getElementById("psm-hero-clear");
  if (heroClear && heroInput) {
    heroClear.addEventListener("click", function () {
      heroInput.value = "";
      heroInput.focus();
    });
  }

  /* ----- mobile drawer chrome ----- */
  var overlay = h('<div class="psm-drawer-overlay"></div>');
  root.appendChild(overlay);
  overlay.addEventListener("click", function () { root.classList.remove("psm-drawer-open"); });
  var closeRow = h('<div class="psm-drawer-close"><button type="button" aria-label="Close filters"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 5l14 14M19 5L5 19"/></svg></button></div>');
  el.facets.insertBefore(closeRow, el.facets.firstChild);
  closeRow.querySelector("button").addEventListener("click", function () { root.classList.remove("psm-drawer-open"); });

  /* ----- boot ----- */
  window.addEventListener("popstate", function () {
    readURL();
    if (el.icsInput) el.icsInput.value = state.q;
    runQuery();
  });

  function boot(cfg) {
    var t = null;
    var wanted = CFG.collection || "__search__";
    // 1) explicit collection assignment wins
    for (var i = 0; i < cfg.trees.length; i++) {
      if (cfg.trees[i].collections.indexOf(wanted) >= 0) { t = cfg.trees[i]; break; }
    }
    // 2) else match by the collection's dominant product type
    if (!t && CFG.collection && cfg.collection_types) {
      var ptype = cfg.collection_types[wanted];
      if (ptype) {
        for (var j = 0; j < cfg.trees.length; j++) {
          if ((cfg.trees[j].product_types || []).indexOf(ptype) >= 0) { t = cfg.trees[j]; break; }
        }
      }
    }
    // 3) else the default tree
    tree = t || cfg.trees[cfg.default_tree];
    CFG.stopwordsSet = cfg.stopwords_set || null;
    readURL();
    if (el.icsInput && state.q) el.icsInput.value = state.q;
    runQuery();
  }
  if (window.__psmFilterConfig) {
    boot(window.__psmFilterConfig);
  } else {
    fetch(CFG.configUrl)
      .then(function (r) { return r.json(); })
      .then(boot)
      .catch(function (e) { console.error("[psm-search] config load failed", e); });
  }
})();
